import React, { useEffect, useState, useCallback, useRef } from 'react';
import useTranslation from '../../../hooks/use-translation';
import { useDropzone } from 'react-dropzone';

import { Document, Page } from "react-pdf";

import apiRequest from '../../../utils/api.request';
import lodash from 'lodash';
import { parseQueryString } from '../../../utils/utils';

import config from '../../../config.json';
import "./uploadVaccineComponent.css";
import uploadButton from '../../../images/uploadButton.svg';
import close from '../../../images/close.svg';

import { vaccinationApiRequestBody } from '../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';

const MAXSIZE = 10485760;
const acceptedImgFileType = ["image/jpeg", "image/png", "image/jpg"]

const vaccinationCertiUploadUrl = config.covid_vacc_base_url + 'v1/upload-reports/'

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;

const UploadVaccineComponent = ({ _onSubmitFinish, noMargin = false, classForStyling = "", onSubmitFailure = () => { } }) => {
  const { t } = useTranslation();
  const [showFileInput, setShowFileInput] = useState(true);
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [imageFile, setImageFile] = useState();
  const [pdfFile, setPdfFile] = useState();
  const [certificateFile, setCertificateFile] = useState();
  const [fileAttachError, setFileAttachError] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [submittingCerti, setSubmittingCerti] = useState(false);
  const [certiUploadError, setCertiUploadError] = useState(false);
  const [certiUploadPercent, setCertiUploadPercent] = useState();
  const params = parseQueryString();

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length) {
      setFileAttachError(t("VACCINATION_CERTI_ATTACH_ERROR"))
      onSubmitFailure()
    }
    if (acceptedFiles.length) {
      setFileAttachError()
      setImageFile()
      setPdfFile()
      setShowFilePreview(true)
      acceptedFiles.forEach((file) => {
        setCertificateFile(file);
        if (acceptedImgFileType.includes(file.type)) {
          setImageFile(URL.createObjectURL(file));
        }
        else {
          setPdfFile(URL.createObjectURL(file))
        }
      })
    }
  }, []);

  useEffect(() => {
    if (!showFileInput) {
      setShowFileInput(true);
    }
  }, [showFileInput])

  const removeFileAndClosePreview = () => {
    setCertificateFile()
    setImageFile()
    setPdfFile()
    setShowFilePreview(false)
    setShowFileInput(false)
    setCertiUploadError()
    setCertiUploadPercent()
  }

  const handleSubmitClicked = async () => {

    auth_token = lodash.get(params, "auth_token");
    source_id = lodash.get(params, "source_id").toLowerCase();
    source_user_id = lodash.get(params, "source_user_id");
    source_relation = lodash.get(params, "source_relation");
    source_user_relation_id = lodash.get(params, "source_user_relation_id");
    const userDetailsObject = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    }
    const dataForFormData = vaccinationApiRequestBody({}, userDetailsObject);
    const formDataForApiRequest = new FormData();
    formDataForApiRequest.append('partner_info', JSON.stringify(dataForFormData));
    formDataForApiRequest.append('file', certificateFile);
    setSubmittingCerti(true);
    const customConfig = {
      onUploadProgress: function (progressEvent) {
        setCertiUploadPercent(Math.round((progressEvent.loaded * 100) / progressEvent.total))
      }
    };
    const response = await apiRequest(vaccinationCertiUploadUrl, formDataForApiRequest, true, false, false, false, false, false, false, null, false, { "Content-Type": "multipart/form-data" }, customConfig)
    setSubmittingCerti(false);

    if (response.apiResponse == "failed") {
      setCertiUploadError(lodash.get(response, "response.data.message", "Something went wrong, please try again"))
    } else {
      setShowFilePreview(false);
      _onSubmitFinish();
    }
  }

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({ onDrop, multiple: false, accept: "image/jpeg, image/png, image/jpg, application/pdf", maxSize: MAXSIZE })
  return (
    <>

      {showFileInput &&
        <div className={`upload-button-container ${noMargin ? "no-margin" : ""} ${classForStyling}`} {...getRootProps()}>
          <input {...getInputProps()} multiple={false} accept={".pdf, .jpeg, .jpg, .png"} className="file-input" capture="camera" />
          {
            isDragActive ?
              isDragReject ? <p className="font-color-red margin-bottom-zero">{t('FILE_DROP_ERROR')}</p> : <p className="margin-bottom-zero">{t('FILE_DROP_TEXT')}</p> :
              <div>
                <div className="upload-button-image"><img height="45px" src={uploadButton} alt="Upload Button Image" /></div>
                {t('DROP_FILE_HERE_OR')} <span className="color-blue">{t('BROWSE')}</span>
                <div className="small-font"><span className="grey-color">{t('DRAG_N_DROP_SUGGESTION')}</span><br /><br /><span dangerouslySetInnerHTML={{ __html: t('FILE_TYPE_SUGGESTIONS') }}></span></div>
              </div>
          }
        </div>
      }
      {fileAttachError && <div className="font-color-red file-attach-error">{fileAttachError}</div>}
      {
        showFilePreview &&
        <div className="file-preview-modal-container">
          <div className="file-preview-modal">
            <div className="close-file-preview">
              <button className={`close-file-preview-button ${submittingCerti ? "disabled" : ""}`} disabled={submittingCerti} onClick={() => removeFileAndClosePreview()}><img src={close} alt="Close Button" /></button>
            </div>
            <div className="file-modal-container">
              <div className="file-modal-header">
                <h4>{t("ATTACHED_FILE")}</h4>
              </div>
              <br />
              <div className="file-preview-container">
                <div>
                  {imageFile && <a href={imageFile} target="_blank"><img className="image-file-preview" src={imageFile} alt="uploadedFile" width="180px" height="200px" /></a>}
                  {pdfFile &&
                    <>
                      <a href={pdfFile} target="_blank" disabled={submittingCerti}>
                        <div className="pdf-file-container">
                          <Document
                            file={pdfFile}
                          >
                            <Page pageNumber={pageNumber} />
                          </Document>
                        </div>
                      </a>
                    </>
                  }
                </div>
              </div>
              <div className="disclaimer-text-container">
                {t("FILE_UPLOAD_DISCLAIMER")}
              </div>
              <div className="file-upload-button-group">
                <div {...getRootProps()} className="upload-another-container" ><input {...getInputProps()} multiple={false} accept={".pdf, .jpeg, .jpg, .png"} className="file-input" capture="camera" /><button className={`upload-file-button ${submittingCerti ? "disabled" : ""}`} disabled={submittingCerti}>{t('REPLACE')}</button></div>
                <div><button className={`upload-file-button upload-file-submit ${submittingCerti ? "disabled" : ""}`} disabled={submittingCerti} onClick={() => handleSubmitClicked()} >{t('SUBMIT')}</button></div>
              </div>
              <br />
              {certiUploadPercent && <div className="uploading-percent">Uploading -- {certiUploadPercent}%</div>}
              {
                certiUploadError &&
                <div className="font-color-red">{certiUploadError}</div>
              }
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default UploadVaccineComponent;